/**
 * Get an array of classes that should be applied based on the classMap
 * definition
 *
 * @example
 * const classMap = {
 *   default: "brk-hello-world-root",
 *   modifierPrefix: "brk-hello-world",
 *   modifiers: [
 *     {
 *       condition: aTruthyValue,
 *       className: "full-width",
 *     },
 *     {
 *       condition: aFalsyValue,
 *       className: "on-dark",
 *     },
 *   ],
 * };
 *
 * getClassList(classMap); // returns ["brk-hello-world-root", "brk-hello-world--full-width"]
 */
function getClassList(classMap) {
  var classList = [];
  if (classMap.default) {
    classList.push(classMap.default);
  }
  var getClass = function getClass(modifierPrefix, className) {
    return modifierPrefix ? "".concat(modifierPrefix, "--").concat(className) : className;
  };
  return classMap.modifiers.reduce(function (acc, modifierClass) {
    if (!modifierClass.condition) {
      return acc;
    }
    // Prefer the modifier class' modiferPrefix over the default if it exists
    var modifierPrefix = typeof modifierClass.modifierPrefix !== "undefined" ? modifierClass.modifierPrefix : classMap.modifierPrefix;
    // Handle an array of modifier classes
    if (Array.isArray(modifierClass.className)) {
      var modifierClasses = modifierClass.className.map(function (className) {
        return getClass(modifierPrefix, className);
      });
      return acc.concat(modifierClasses);
    }
    acc.push(getClass(modifierPrefix, modifierClass.className));
    return acc;
  }, classList);
}

export { getClassList as default };
